import React, { PropsWithChildren } from 'react';
import { selectUserFetchStatus } from '../../slices/user/userSlice';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { useHasClerkRole } from '../hooks/useHasClerkRole';
import { useAuth } from '@clerk/clerk-react';
import { useCheckPermission } from '../hooks/useCheckPermission';

interface RolesGateProps {
  role?: string;
  permission?: string | string[];
  group?: string;
}

export const PermissionsGate = ({ permission, children }: PropsWithChildren<RolesGateProps>) => {
  const checkPermission = useCheckPermission();
  const userHasPermission = Array.isArray(permission)
    ? permission.some((el) => checkPermission(el))
    : checkPermission(permission);

  if (userHasPermission) {
    return <>{children}</>;
  }

  return null;
};

export const RolesGate = ({ role, children }: PropsWithChildren<RolesGateProps>) => {
  const userHasRole = useHasClerkRole(role);

  if (userHasRole) {
    return <>{children}</>;
  }

  return null;
};

export const RolesGateRedirect = ({ role, children }: PropsWithChildren<RolesGateProps>) => {
  const userHasRole = useHasClerkRole(role);
  const status = useSelector(selectUserFetchStatus);

  if (status === 'loading' || !status) {
    return null;
  }

  if (userHasRole) {
    return <>{children}</>;
  }

  return <Navigate to={ROUTES.HOME} replace />;
};

export const PermissionGateRedirect = ({
  permission,
  children,
}: PropsWithChildren<RolesGateProps>) => {
  const { has } = useAuth();
  const userHasPermission = Array.isArray(permission)
    ? permission.some((el) => has({ permission: el }) || has({ permission: 'org:' + el }))
    : has({ permission }) || has({ permission: 'org:' + permission });
  const status = useSelector(selectUserFetchStatus);

  if (status === 'loading' || !status) {
    return null;
  }

  if (userHasPermission) {
    console.log('userHasPermission =', userHasPermission);
    return <>{children}</>;
  }

  return <Navigate to={ROUTES.HOME} replace />;
};
